import { ReactNode } from 'react'

interface DashboardCardProps {
  title: string
  children: ReactNode
  actions?: ReactNode
  loading?: boolean
  error?: string
  className?: string
}

export default function DashboardCard({
  title,
  children,
  actions,
  loading = false,
  error,
  className = '',
}: DashboardCardProps) {
  return (
    <div className={`card ${className}`}>
      <div className="card-header">
        <div className="flex items-center justify-between">
          <h3 className="text-lg leading-6 font-medium text-gray-900">{title}</h3>
          {actions && <div className="flex items-center space-x-2">{actions}</div>}
        </div>
      </div>

      <div className="card-body">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <div className="text-sm text-red-700">
              <p>Error loading data: {error}</p>
            </div>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  )
}
